import React from "react";
import { Box, Card, CardContent, Chip, Divider, Grid, Typography } from "@mui/material";
import { TEXT } from "../../dark-theme/palette";
import UtilService from "../../services/UtilService";
import AnimatedClock from "./AnimatedClock";

export default function CardEventInformation({ event, timeRemaining, formatTimeRemaining, getTimeRemainingColor, getClockColor }) {
    if (!event) return null;

    return (
        <Grid size={{ xs: 12 }}>
            <Card>
                <CardContent>
                    <Typography variant="h5" gutterBottom>
                        {event.name}
                    </Typography>
                    <Divider sx={{ my: 2 }} />
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                    p: 2,
                                    borderRadius: 2,
                                    backgroundColor: timeRemaining?.isOver
                                        ? "rgba(244, 67, 54, 0.16)"
                                        : timeRemaining?.days === 0 && timeRemaining?.hours < 24
                                            ? "rgba(255, 152, 0, 0.16)"
                                            : timeRemaining?.days <= 3
                                                ? "rgba(255, 193, 7, 0.16)"
                                                : "rgba(76, 175, 80, 0.16)",
                                    border: `2px solid ${timeRemaining?.isOver
                                        ? "#f44336"
                                        : timeRemaining?.days === 0 && timeRemaining?.hours < 24
                                            ? "#ff9800"
                                            : timeRemaining?.days <= 3
                                                ? "#ffc107"
                                                : "#4caf50"
                                        }`,
                                }}
                            >
                                <AnimatedClock color={getClockColor()} size={60} />
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                        {timeRemaining?.isOver ? "Event Status" : "Time Remaining"}
                                    </Typography>
                                    <Typography
                                        variant="h5"
                                        sx={{
                                            fontWeight: 700,
                                            color:
                                                timeRemaining?.isOver
                                                    ? "#f44336"
                                                    : timeRemaining?.days === 0 && timeRemaining?.hours < 24
                                                        ? "#ff9800"
                                                        : timeRemaining?.days <= 3
                                                            ? "#ffc107"
                                                            : "#4caf50",
                                        }}
                                    >
                                        {formatTimeRemaining()}
                                    </Typography>
                                </Box>
                                {!timeRemaining?.isOver && (
                                    <Chip
                                        label={formatTimeRemaining()}
                                        color={getTimeRemainingColor()}
                                        size="large"
                                        sx={{ fontWeight: 600, fontSize: "0.9rem" }}
                                    />
                                )}
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Typography variant="subtitle2" color="text.secondary">
                                Start Date
                            </Typography>
                            <Typography variant="body1">
                                {event.startAt ? UtilService.formatDate(event.startAt) : "-"}
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Typography variant="subtitle2" color="text.secondary">
                                End Date
                            </Typography>
                            <Typography variant="body1">
                                {event.endAt ? UtilService.formatDate(event.endAt) : "-"}
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Typography variant="subtitle2" color="text.secondary">
                                Required Invites
                            </Typography>
                            <Typography variant="body1">{event.requiredCount || "-"}</Typography>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Typography variant="subtitle2" color="text.secondary">
                                Reward
                            </Typography>
                            <Typography variant="body1">
                                {event.rewardMonths || 0} month{event.rewardMonths !== 1 ? "s" : ""} free subscription
                            </Typography>
                        </Grid>
                    </Grid>
                    <Box
                        sx={{
                            mt: 3,
                            p: 2,
                            backgroundColor: timeRemaining?.isOver
                                ? "rgba(244, 67, 54, 0.16)"
                                : "rgba(76, 175, 80, 0.16)",
                            borderRadius: 1,
                            border: `1px solid ${timeRemaining?.isOver ? "#f44336" : "#4caf50"}`,
                        }}
                    >
                        {timeRemaining?.isOver ? (
                            <Typography variant="body2" color="error" sx={{ fontWeight: 500 }}>
                                This event has ended. Thank you for participating!
                            </Typography>
                        ) : (
                            <>
                                <Typography 
                                    variant="body1" 
                                    sx={{ 
                                        fontWeight: 400,
                                        color: TEXT.secondary,
                                        lineHeight: 1.7
                                    }}
                                >
                                    If you invite{" "}
                                    <Box component="span" sx={{ fontWeight: 700, color: TEXT.primary }}>
                                        {event.requiredCount || 5} people
                                    </Box>{" "}
                                    and they join, you'll get{" "}
                                    <Box component="span" sx={{ fontWeight: 700, color: TEXT.primary }}>
                                        {event.rewardMonths || 1} month{event.rewardMonths !== 1 ? "s" : ""} free
                                    </Box>{" "}
                                    subscription.
                                </Typography>
                                <Typography 
                                    variant="body2" 
                                    sx={{ 
                                        mt: 1.5,
                                        fontWeight: 400,
                                        color: TEXT.secondary,
                                        lineHeight: 1.6
                                    }}
                                >
                                    Your invitees need to{" "}
                                    <Box component="span" sx={{ fontWeight: 700, color: TEXT.primary }}>
                                        sign up (FREE)
                                    </Box>{" "}
                                    and{" "}
                                    <Box component="span" sx={{ fontWeight: 700, color: TEXT.primary }}>
                                        signin
                                    </Box>{" "}
                                    at least once to be counted.
                                </Typography>
                            </>
                        )}
                    </Box>
                </CardContent>
            </Card>
        </Grid>
    );
}

